






























































































































































































































































































































































































import Vue from 'vue'
import Nav from '@/components/Nav.vue'
import { mapState } from 'vuex'
import { ApiResponse, BankDeposit, Structure } from '@/interfaces'
import { paymentTypes } from '@/formHelpers'
import { DatePicker } from 'element-ui'

interface lastNumberStructure {
  structureId: string
  lastNumber: string
}

interface Badge {
  type: string
  value: string
}

interface BankAccount {
  value: string
  label: string
  structureId: number
}

export default Vue.extend({
  components: { Nav },
  data() {
    return {
      bankDeposits: [] as BankDeposit[],
      period: [] as string[],
      periodOptions: {
        shortcuts: [
          {
            text: 'Mois dernier',
            onClick(picker: DatePicker) {
              const start = new Date()
              const startMonth = start.getMonth() - 1
              start.setDate(1)
              start.setMonth(startMonth)
              const end = new Date(start.getFullYear(), startMonth + 1, 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Mois en cours',
            onClick(picker: DatePicker) {
              const start = new Date()
              start.setDate(1)
              const end = new Date(start.getFullYear(), start.getMonth() + 1, 0)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      structures: [] as Structure[],
      structureFilter: null as number | null,
      states: [
        { value: 'en_cours', label: 'En Cours', type: '' },
        { value: 'comptabilisee', label: 'Comptabilisée', type: 'success' },
      ],
      showDepositModal: false,
      allBankAccounts: [],
      bankAccounts: [],
      paymentTypes,
      paymentTypeFilter: null as string | null,
      bankDepositFormData: {} as BankDeposit,
      bankDepositFormIndex: null as number | null,
      lastNumberByStructure: [] as lastNumberStructure[],
      busy: false,
      numberFilter: null as string | null,
      amountFilter: null as string | null,
      addons: 0,
      selectedIds: [] as number[],
      totalAmount: 0,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  watch: {
    user(newVal) {
      this.structures = newVal.client?.structures
      this.addons = newVal.client?.addons ?? 0
    },
  },
  mounted() {
    if (this.user) {
      this.addons = this.user.client?.addons ?? 0
    }

    const filterKeys = ['structure', 'period', 'paymentType', 'number', 'amount']
    const hasFiltersInUrl = filterKeys.some((key) => key in this.$route.query)
    if (hasFiltersInUrl) {
      const query = this.$route.query
      const period = query.period
      this.structureFilter = query.structure ? parseInt(query.structure as string) : null
      this.period = Array.isArray(period) ? (period as string[]) : period ? [period as string] : []
      this.paymentTypeFilter = (query.paymentType as string) ?? null
      this.numberFilter = (query.number as string) ?? null
      this.amountFilter = (query.amount as string) ?? null
      this.fetchBankDeposits()
    }
    this.fetchBankAccounts()

    if (this.user?.client?.structures) {
      this.structures = this.user?.client?.structures
    }
  },
  methods: {
    updateFilter() {
      const period = this.normalizePeriodForParis(this.period)
      this.$router
        .replace({
          query: {
            structure: this.structureFilter?.toString(),
            period,
            paymentType: this.paymentTypeFilter || undefined,
            number: this.numberFilter || undefined,
            amount: this.amountFilter || undefined,
          },
        })
        .catch((error) => error)
      this.fetchBankDeposits()
    },
    normalizePeriodForParis(period: any) {
      if (!period || !Array.isArray(period) || period.length === 0) return []

      const formatInParis = (input: any) => {
        if (!input) return null
        if (typeof input === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(input)) return input

        const d = typeof input === 'string' ? new Date(input) : input instanceof Date ? input : new Date(input)
        if (isNaN(d.getTime())) return null

        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Paris',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).formatToParts(d)

        let year = ''
        let month = ''
        let day = ''
        parts.forEach((p) => {
          if (p.type === 'year') year = p.value
          if (p.type === 'month') month = p.value
          if (p.type === 'day') day = p.value
        })
        if (year && month && day) {
          return `${year}-${month}-${day}`
        }
        return null
      }

      return period.map((p: any) => formatInParis(p)).filter((x: any) => x !== null)
    },
    fetchBankDeposits() {
      this.bankDeposits = []
      if (!this.period) {
        this.period = []
      }
      if (!this.busy) {
        this.busy = true

        const loading = this.$loading({
          target: '#bankDepositsTable',
          text: 'Chargement des données...',
        })

        // Normalize period to date-only strings in Europe/Paris to avoid timezone shifts
        const periodParam = this.normalizePeriodForParis(this.period)

        this.$api
          .get('/bank-deposits', {
            params: {
              structure: this.structureFilter,
              period: periodParam,
              paymentType: this.paymentTypeFilter,
              number: this.numberFilter,
              amount: this.amountFilter,
            },
          })
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            this.bankDeposits = apiResponse.data.bankDeposits
            this.lastNumberByStructure = apiResponse.data.lastNumberByStructure
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Erreur',
              message: 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          })
          .finally(() => {
            this.busy = false
            loading.close()
            this.resetBankDepositFormData()
            this.closeDepositModal()
          })
      }
    },
    fetchBankAccounts() {
      this.allBankAccounts = []

      this.$api
        .get('/bank-accounts')
        .then((response) => {
          const apiResponse = response.data as ApiResponse

          this.allBankAccounts = apiResponse.data
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Erreur',
            message: 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
          })
        })
    },
    submit() {
      const data = {
        ...this.bankDepositFormData,
      }
      delete data.structure
      const loading = this.$loading({
        target: '#bankDepositsTable',
        text: 'Chargement des données...',
      })

      if (!this.bankDepositFormData.id) {
        // Store
        this.$api
          .post('/bank-deposit', data)
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            this.bankDeposits.unshift(apiResponse.data.newBankDeposit)
            this.lastNumberByStructure = apiResponse.data.lastNumberByStructure
            this.$notify({
              type: 'success',
              title: 'Succès',
              message: 'Remise en banque créée avec succès !',
            })
          })
          .catch((error) => {
            if (error.response) {
              const apiResponse = error.response.data as ApiResponse

              this.$notify({
                type: 'error',
                title: 'Erreur',
                message:
                  apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
              })
            }
          })
          .finally(() => {
            this.busy = false
            this.resetBankDepositFormData()
            this.closeDepositModal()
            loading.close()
          })
      } else {
        // Edit
        this.$api
          .put(`/bank-deposit/${this.bankDepositFormData.id}`, {
            data,
            period: this.period,
            number: this.numberFilter,
            amount: this.amountFilter,
            structure: this.structureFilter ?? '',
          })
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            this.bankDeposits = apiResponse.data
            this.$notify({
              type: 'success',
              title: 'Succès',
              message: 'Remise en banque modifiée avec succès !',
            })
          })
          .catch((error) => {
            if (error.response) {
              const apiResponse = error.response.data as ApiResponse

              this.$notify({
                type: 'error',
                title: 'Erreur',
                message:
                  apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
              })
            }
          })
          .finally(() => {
            this.busy = false
            this.resetBankDepositFormData()
            this.closeDepositModal()
            loading.close()
          })
      }
    },
    updateBankDepositForm(structureId: string) {
      let bankDepositChrono = this.lastNumberByStructure.find(
        (structure: lastNumberStructure) => structure.structureId === structureId
      )
      if (bankDepositChrono) {
        this.bankDepositFormData.depositNumber = parseInt(bankDepositChrono.lastNumber) + 1
      } else {
        this.bankDepositFormData.depositNumber = 1
      }
      delete this.bankDepositFormData.bankAccount
      this.getBankAccount(structureId)
    },
    getBankAccount(structureId: string | null) {
      this.bankAccounts = this.allBankAccounts.filter(
        (bankAccount: BankAccount) => bankAccount.structureId.toString() === structureId
      )
    },
    resetBankDepositFormData() {
      this.bankDepositFormData = {}
      this.bankDepositFormIndex = null
    },
    deleteBankDeposit(bankDeposit: BankDeposit, index: number) {
      this.$confirm('Êtes-vous sûr(e) de vouloir supprimer cette remise ?', 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning',
      }).then(() => {
        this.$api
          .delete(`/bank-deposit/${bankDeposit.id}`)
          .then(() => {
            this.bankDeposits.splice(index, 1)
            this.$notify({
              type: 'success',
              title: 'Succès',
              message: 'Remise en banque supprimée avec succès !',
            })
          })
          .catch((error) => {
            if (error.response) {
              const apiResponse = error.response.data as ApiResponse

              this.$notify({
                type: 'error',
                title: 'Erreur',
                message:
                  apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
              })
            }
          })
          .finally(() => {
            this.resetBankDepositFormData()
          })
      })
    },
    generateDepositDocument(bankDeposit: BankDeposit | null) {
      if (!this.busy) {
        this.busy = true

        const ids = Object.assign([], this.selectedIds)

        // Si jamais on vaut generer un PDF, mais pas fait du coté API car utilité pas flagrante
        const data = {
          ids: ids,
        }

        if (bankDeposit != null && bankDeposit.id) {
          data.ids.push(bankDeposit.id)
        }

        this.$api
          .post(`/bank-deposit/generate/receipt`, data)
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            //this.bankDeposits = apiResponse.data.bankDeposits
            //const documentUrl = `${process.env.VUE_APP_API_URL}/document/bank-deposit-receipt/${apiResponse.data.filename}/${this.user.client.id}/download`
            const documentUrl = `${process.env.VUE_APP_API_URL}/document/${apiResponse.data.filename}/download_once?contentd=inline`
            window.open(documentUrl, '_blank')
          })
          .catch((error) => {
            if (error.response) {
              const apiResponse = error.response.data as ApiResponse

              this.$notify({
                type: 'error',
                title: 'Erreur',
                message:
                  apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
              })
            }
          })
          .finally(() => {
            this.busy = false
          })
      }
    },
    depositExport(bankDeposit: BankDeposit | null, type: string) {
      if (!this.busy) {
        this.$confirm("Souhaitez-vous mettre à jour l'état de la remise à comptabilisée ?", 'Confirmation', {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non',
          type: 'warning',
        })
          .then(() => {
            this.generateDepositExportDocument(bankDeposit, type, true)
          })
          .catch((action) => {
            if (action === 'cancel') {
              this.generateDepositExportDocument(bankDeposit, type, false)
            }
          })
      }
    },
    generateDepositExportDocument(bankDeposit: BankDeposit | null, type: string, updateState: boolean) {
      if (!this.busy) {
        this.busy = true

        const ids = Object.assign([], this.selectedIds)

        const data = {
          ids: ids,
          updateState: updateState,
        }

        if (bankDeposit != null && bankDeposit.id) {
          data.ids.length = 0
          data.ids.push(bankDeposit.id)
        }

        this.$api
          .post(`/bank-deposit/generate/${type}`, data, {
            params: {
              structure: this.structureFilter,
              period: this.normalizePeriodForParis(this.period),
              paymentType: this.paymentTypeFilter,
              number: this.numberFilter,
              amount: this.amountFilter,
            },
          })
          .then((response) => {
            const apiResponse = response.data as ApiResponse
            // rafraichissement de la liste
            this.bankDeposits = apiResponse.data.bankDeposits

            const documentUrl = `${process.env.VUE_APP_API_URL}/document/${apiResponse.data.filename}/download_once`
            window.open(documentUrl, '_blank')
          })
          .catch((error) => {
            if (error.response) {
              const apiResponse = error.response.data as ApiResponse

              this.$notify({
                type: 'error',
                title: 'Erreur',
                message:
                  apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
              })
            }
          })
          .finally(() => {
            this.busy = false
          })
      }
    },
    formatDate(str: string): string {
      const date = Date.parse(str)
      if (!isNaN(date)) {
        return new Intl.DateTimeFormat('fr-FR').format(date)
      } else {
        return '-'
      }
    },
    formatCurrency(amount: number) {
      return Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount).toString()
    },
    getStateBadge(bankDeposit: BankDeposit): Badge {
      const filteredState = this.states.find((state) => state.value === bankDeposit.state)

      return {
        type: filteredState?.type ?? '',
        value: filteredState?.label ?? '-',
      }
    },
    getPaymentType(bankDeposit: BankDeposit) {
      return this.paymentTypes.find((payment) => payment.value === bankDeposit.type)?.label ?? ''
    },
    getBankLabel(bankDeposit: BankDeposit) {
      const selectedBankAccount = this.allBankAccounts.find(
        (bankAccount: BankAccount) =>
          bankAccount.structureId === bankDeposit.structureId &&
          bankAccount.value === bankDeposit.bankAccount?.toString()
      ) as BankAccount | undefined
      return selectedBankAccount ? selectedBankAccount?.label : '-'
    },
    // displayPaymentList(row: BankDeposit, column: Record<string, string>, cell: HTMLTableCellElement): void {
    //   if (!cell.classList.contains('actions')) {
    //     this.goToPaymentList(row)
    //   }
    // },
    goToPaymentList(bankDeposit: BankDeposit) {
      if (bankDeposit.id) {
        this.$router.push({
          name: 'payments',
          query: {
            depositId: bankDeposit.id?.toString(),
          },
        })
      }
    },
    openDepositModal(bankDeposit: BankDeposit | null = null, index: number | null = null) {
      if (bankDeposit) {
        this.bankDepositFormData = {
          ...bankDeposit,
        }
        this.bankDepositFormIndex = index
        this.getBankAccount(bankDeposit.structureId ? bankDeposit.structureId.toString() : '')
      }
      this.showDepositModal = true
    },
    closeDepositModal() {
      this.showDepositModal = false
      this.resetBankDepositFormData()
      this.bankAccounts = []
    },
    handleClose(done: CallableFunction) {
      this.closeDepositModal()
      done()
    },
    handleSelectionChange(selectedItems: BankDeposit[]) {
      this.selectedIds = []
      selectedItems.forEach((selectedItem) => {
        if (selectedItem?.id) {
          this.selectedIds?.push(selectedItem.id)
        }
      })
      this.totalAmount = selectedItems.reduce((acc, selectedItem) => acc + (selectedItem?.total ?? 0), 0)
    },
    getSummary() {
      const count = this.selectedIds?.length ?? 0
      return count + ' remise(s) pour un total de ' + this.formatCurrency(this.totalAmount)
    },
    handleItemCommand(command: string) {
      if (command == 'massExportExeve') {
        this.depositExport(null, 'export')
      }
      if (command == 'massExportCiel') {
        this.depositExport(null, 'exportCiel')
      }
      if (command == 'massExportRV') {
        this.depositExport(null, 'exportRV')
      }
      if (command == 'massExportFec') {
        this.depositExport(null, 'fec')
      }
    },
  },
})
